import {
  EIDM_EDIT,
  EIDM_EDIT_ERROR,
  EIDM_GET_BY_QUERY,
  EIDM_GET_BY_ID,
  EIDM_GET_BY_ID_SUCCESS,
  EIDM_GET_BY_QUERY_SUCCESS,
  EIDM_GET_BY_QUERY_ERROR,
  EIDM_ADD_NEW_REQUEST,
  EIDM_DELETE,
  EIDM_DELETE_SUCCESS,
} from './types';
// item
const initialState = {
  item: null,
  items: [],
  loading: false,
  error: null,
  itemCount: 0,
  pageCount: 0,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
};

export default function initState(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case EIDM_DELETE:
    case EIDM_GET_BY_ID:
    case EIDM_GET_BY_QUERY:
      return {
        ...state,
        loading: true,
        error: null,
        editSuccess: false,
        item: null,
      };
    case EIDM_ADD_NEW_REQUEST:
      return {
        ...state,
        loading: false,
        item: null,
        error: null,
      };
    case EIDM_GET_BY_QUERY_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        loading: false,
        // items: payload,
        items: data,
        itemCount,
        pageCount,
      };

    case EIDM_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        item: payload,
      };

    case EIDM_EDIT:
      return {
        ...state,
        loading: true,
        error: null,
        editSuccess: false,
      };

    case EIDM_EDIT_ERROR:
    case EIDM_GET_BY_QUERY_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
}
